export default __webpack_public_path__ + "static/media/edit.f02418f8.svg";